// extracted by mini-css-extract-plugin
export default {"btnpwd":"_4dd019fc61"};